import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(null);

function load() {
  try {
    const arr = JSON.parse(localStorage.getItem("rnf_cart") || "[]");
    return Array.isArray(arr) ? arr.filter((i) => i && i.lid && i.measurements) : [];
  } catch (e) { return []; }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);

  useEffect(() => {
    localStorage.setItem("rnf_cart", JSON.stringify(items));
  }, [items]);

  const genId = () => Math.random().toString(36).slice(2) + Date.now().toString(36);

  const add = (item) => {
    const lid = genId();
    setItems((prev) => [...prev, { ...item, lid, quantity: 1 }]);
    return lid;
  };

  const update = (lid, patch) =>
    setItems((prev) => prev.map((p) => (p.lid === lid ? { ...p, ...patch } : p)));

  const remove = (lid) => setItems((prev) => prev.filter((p) => p.lid !== lid));
  const clear = () => setItems([]);

  const count = items.length;
  const subtotal = items.reduce((s, i) => s + (i.price || 0), 0);

  return (
    <CartContext.Provider value={{ items, add, update, remove, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
